import { Injectable, NgZone } from "@angular/core";
import { CoralogixRum } from "@coralogix/browser";
import { UserProfile } from "../shared/types/UserProfile";
import { environment } from "../../environments/environment";

@Injectable({providedIn: "root"})
export class CoralogixRUMService {
  private static sdk: typeof CoralogixRum | null = null;
  private static readonly coralogixPublicKey = 'cxtp_DoH3xlzhCx7w9iGxqX3c3gzywzH2sn';
  private static readonly coralogixAppName = 'insight-hub-console-client';

  constructor(private ngZone: NgZone) {
  }

  public static init(): void {
    if (this.sdk || !['qa', 'prod'].includes(environment.env)) { // Avoid user tracking in local/dev environments.
      return;
    }
    
    this.sdk = CoralogixRum;
    this.sdk.init({
      public_key: this.coralogixPublicKey,
      application: this.coralogixAppName,
      version: `3.48.4068-${environment.env}`,
      coralogixDomain: 'US2',
      environment: environment.env,
      ignoreErrors: [], // TODO consider adding irrelevant errors to this list in order to reduce noise and costs. both regexes and strings are supported
      networkExtraConfig: [
        {
          url: new RegExp(".*"),
          collectReqPayload: true,
          collectResPayload: true
        }
      ]
    });
  }

  public identify(user: UserProfile): void {
    this.ngZone.runOutsideAngular(() => {
      CoralogixRUMService.sdk?.setUserContext({
        user_id: user.id,
        user_name: `${user.firstName} ${user.lastName}`,
        user_email: user.email,
        user_metadata: {
          role: user.role,
        }
      })
    });
  }
}
